export const USERNAME_PASSWORD = 'USERNAME_PASSWORD';
export const USERNAME_PASSWORD_WEBSSO = 'USERNAME_PASSWORD_WEBSSO';
export const SMS_ENROLL_PHONE = 'SMS_ENROLL_PHONE';
export const SMS_ENROLL_VERIFY = 'SMS_ENROLL_VERIFY';
export const IID_ENROLL = 'IID_ENROLL';
export const IID_PUSH = 'IID_PUSH';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const SECOND_FACTOR = 'SECOND_FACTOR';
export const SELF_SERVICE_START = 'SELF_SERVICE_START';
export const SELF_SERVICE_END = 'SELF_SERVICE_END';
export const SELF_SERVICE_ENROLL = 'SELF_SERVICE_ENROLL';
